// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, " [data-v-3ff48e08-host].accordion--main-menu .toggle,:host(.accordion--main-menu) .toggle {\n  width: 100%;\n}", ""]);
// Exports
module.exports = exports;
